export enum Directions {
  Down = `down`,
  DownCenter = `downCenter`,
  DownRight = `downRight`,
  Right = `right`,
  RightCenter = `rightCenter`,
  RightBottom = `rightBottom`,
  Up = `up`,
  UpRight = `upRight`,
  UpCenter = `upCenter`,
  Left = `left`,
  LeftCenter = `leftCenter`,
  LeftBottom = `leftBottom`,
}

export enum PositioningStrategy {
  Absolute = `absolute`,
  Fixed = `fixed`,
}

export enum PositionParentType {
  OffsetParent = `offsetParent`,
  ParentElement = `parentElement`,
}

// use "const enum" for backward compatibility with raw menu state strings
// "const enum" forces Typescript to simply inline the enum value when compiled
export const enum MenuState {
  Open = `open`,
  Closed = `closed`,
}
